import React from 'react';

const DevExpressDropdownButton = () => 
  <div className="dx-texteditor-buttons-container">
    <div className="dx-dropdowneditor-button dx-button-normal dx-button-mode-contained dx-widget">
      <div className="dx-button-content">
        <div className="dx-dropdowneditor-icon"></div>
      </div>
    </div>
  </div>

  export default DevExpressDropdownButton;
  